export default {
  all_in_lift: {
    label: 'Est-ce que tous les meubles rentrent dans l\'ascenseur ?',
  },
  stairs: {
    label: 'Est-ce que tous les meubles passent par l\'escalier ?',
  },
  mm_utilisable: {
    label: 'Peut-on utiliser un monte-meubles ?',
  },
  mm_obligatoire: {
    label: 'Souhaitez-vous que les déménageurs utilisent un monte-meubles ?',
  },
};
